<template>
  <b-container class="px-0 mx-0 active" fluid="true" style="height: 100%">
    <VBox style="position: relative; z-index: 0;">
      <EntitiesList
          ref="entititesList"
          @row-selected="bubble('row-selected', $event)"
          @rows-selected="bubble('row-selected', $event)"
          @row-index-selected="bubble('row-index-selected', $event)"
          @rows-indices-selected="bubble('rows-indices-selected', $event)"
          @selection-clear="bubble('selection-clear', $event)"
          @before-sorting="bubble('before-sorting', $event)"
          @after-sorting="bubble('after-sorting', $event)"
          @export="bubble('export', $event)"
          @search="bubble('search', $event)"
          @loading-data="bubble('loading-data', $event)"
          @start-loading-data="bubble('start-loading-data', $event)"
          @markReadyToShow="markReadyToShow"

          :select-mode="selectMode"
          :grid-name="mode === 'select' ? ('act-' + formConfig.formClassLong) + 'select' : ('act-' + formConfig.formClassLong)"
          :form="formConfig"
          v-model="selectedEntity"
          :selectedIndex.sync="selectedIndex"
          :selectionSize.sync="selectionSize"
          :showMultiSelect.sync="showMultiSelect"
          :editMultiSelectFromTab.sync="editMultiSelectFromTab"
          :listOfDynamicPreparedObjectForColumns="listOfDynamicPreparedObjectForColumns"
          :uniqueDataForColoringDynamicColumns="uniqueDataForColoringDynamicColumns"

          @rowSelected="capture"
          :filtering-mode="filteringMode"
          :showAdd="effectiveHasWriteAccessToMaster && formConfig.writePermitted && showAdd && formConfig.showAdd && contextShowAdd"
          :showDelete="effectiveHasWriteAccessToMaster && formConfig.writePermitted && showDelete && formConfig.showDelete && contextShowDelete"
          :showDetails="formConfig.readPermitted && showDetails && (mode !== 'select' || editInSelectMode)"
          :columns-mixins="columnMixins"
          :show-columns="formConfig.showColumns"
          :custom-data-loader="customDataLoader"
          :custom-items="items"
          :recordsWithChosenFilters="recordsWithChosenFilters"

          :multiSelectAutoOn="multiSelectAutoOn"

          :details-config="detailsConfig || (context && context.allProps ? context.allProps.detailsConfig:null)"
          :details-master-id="detailsMasterId || (context && context.allProps ? context.allProps.masterId:null)"
          :details-mode="detailsMode || (context && context.allProps ? context.allProps.mode:null)"
          :details-temporary-list="detailsTemporaryList || (context && context.allProps ? context.allProps.temporaryList:null)"
          :details-master-form-config="detailsMasterFormConfig || (context && context.allProps ? context.allProps.masterFormConfig:null)"
          :meta-status="metaStatus || (context && context.allProps ? context.allProps.metaStatus:null)"

          @delete="deleteEntity"
          @add="addEntity"
          @details="details"
          @import="importData"
          @row-dblclicked="showDetailsOrSelect"
          :excluded-ids="context ? context.excludedIds : null"
          :only-ids="context ? context.onlyIds : null"
          :formValidatedFieldWithParent="context ? context.formValidatedFieldWithParent : null"
          :toolboxMixins="toolboxMixins"
          :filter="filter"
          :customDataLoader="customDataLoader"
          :context="context"
          :stream-rows-post-process="streamRowsPostProcess"
      >
        <template slot="above-grid">
          <slot name="above-grid"></slot>
        </template>
        <!-- w przyszlosci ty moga wejsc customowe opcje do menu -->
      </EntitiesList>
    </VBox>

    <FooterNavbar v-if="(!context || !context.isTab) && readyToShow"
                  :data-test-path="'form-list-footer:' + formConfig.formClass">
      <template v-slot:info>
        <div v-if="selectionSize && showMultiSelect" style="padding-top:8px; width: 100px; text-align: left">
          &#9745; {{ selectionSize }}
        </div>
      </template>
      <CloseButton @close="close" v-if="!context || context.mode === 'default'"></CloseButton>
      <footer-button type="Cancel" @cancel="close" v-else></footer-button>

      <footer-button type="Clear" @clear="clear" v-if="mode === 'select' && allowNullSelection"></footer-button>
      <footer-button type="Select" @select="select" v-if="mode === 'select'"
                     :disabled="!anySelectionItem"></footer-button>
    </FooterNavbar>

  </b-container>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import EntitiesList from "@/components/forms/EntitiesList";

import FooterButton from "@/components/navbar/FooterButton";
import FormsActions, {MULTISELECT_ID_ONLY} from "@/components/forms/FormsActions";
import FormsLoader from "@/components/forms/FormsLoader";
import CloseButton from "@/components/navbar/CloseButton";
import FormsListContext from "@/activity/templates/layouts/forms/FormsListContext"
import FormsAI from "@/components/forms/FormsAI";
import DefaultCellTextRenderer from "@/components/datagrid/DefaultCellTextRenderer.vue";
import {VGridVueTemplate} from "@entestat/vue-datagrid";
import {
  checkIfThereAreDynamicFieldsOnTheGrid,
  getAllRecordsFromDatabaseWithDynamicCells,
  getAllRecordsFromDatabaseWithDynamicColumns, getAllRecordsFromDatabaseWithRows,
  getFilteredRecordsFromDatabaseWithRows, getRecordsFromDatabaseWithRowsWhenStreaming
} from "@/components/forms/customizations/plm/DynamicColumnsService";
import {deleteAsStream} from "@/components/forms/customizations/plm/EntitiesListService";
import DialogManager from "@/utils/DialogManager";
import Rpc from "@/Rpc";
import SessionManager from "@/utils/SessionManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";

export default {
  name: "FormsListActivity",

  components: {CloseButton, FooterButton, EntitiesList, VBox, FooterNavbar},

  created() {
    // const bufferSize = 50 * 1024 * 1024; // 50MB
    // this.bomb  = new ArrayBuffer(bufferSize);

    if (this.context) {
      this.mode = this.context.mode;
      this.allowNullSelection = this.context?.allowNullSelection ?? this.context?.formValidatedFieldWithParent?.formFieldConfig?.allowNull ?? true;
    }
    if (this.recordsWithChosenFilters) {
      // this.selectedEntity = this.recordsWithChosenFilters;

      for (let item of this.recordsWithChosenFilters) {
        this.$emit('selected', item);
      }
    }
  },
  async beforeMount() {
  },
  events: ["add", "details", "delete", "selected", "selectedIndex"],
  async mounted() {
    if (this.context?.formTitle) {
      this.title = this.context.formTitle;
    } else {
      this.title = this.formConfig?.formTitle;
    }
    if (this.multiSelect || this.context?.multiSelect || this.propMultiSelect) {
      this.selectMode = "range";
    } else {
      if (this.formConfig?.multiGroupDeleteAllow || this.formConfig?.isView) {
        if (this.mode !== "select") {
          this.selectMode = "range";
        }
      } else {
        this.selectMode = "single";
      }
    }
    if (this.context?.showAdd === false) {
      this.contextShowAdd = false;
    }
    if (this.context?.showDelete === false) {
      this.contextShowDelete = false;
    }

    if (await checkIfThereAreDynamicFieldsOnTheGrid(this.formConfig)) {
      await this.loadDynamicData();
      await this.createDynamicColumns()
    }

    this.$refs.entititesList?.observeKeyboard();
  },
  methods: {

    bubble(ev, data) {
      if (!data) {
        this.$emit(ev);
      }
      this.$emit(ev, data);
    },

    getTitle() {
      if (this.context?.activityType === Activity.SELECT) {
        return "Select " + this.formConfig?.entityName;
      }
      if (this.context?.activityType === Activity.SELECT_REPLACEMENT) {
        return "Select replacement for deleted " + this.formConfig?.entityName;
      }

      return this.formConfig?.formTitle;
    },

    markReadyToShow() {
      this.readyToShow = true;
      this.$emit("markReadyToShow")
    },


    capture() {
      console.log("captured");
    },

    close() {
      ActivityManager.closeTopActivity();
    },

    async addEntity() {
      let masterId = this.detailsMasterId || (this.context && this.context.allProps ? this.context.allProps.masterId : null);
      if (this.formConfig.hasConditionalAdd) {
        let addInfo = await Rpc.Forms.canAdd(this.formConfig.formClassLong, masterId);
        if (addInfo) {
          await DialogManager.info($tr("cantAdd", "Can't add"), addInfo);
          return;
        }
      }
      // if (this.mode === 'select' && !this.editInSelectMode) {
      //   return;
      // }
      let res = await this.$emit("add");
      if (this.customAdd) {
        return;
      }


      let masterFormConfig = this.detailsMasterFormConfig || (this.context && this.context.allProps ? this.context.allProps.masterFormConfig : null);
      let detailsConfig = this.detailsConfig || (this.context && this.context.allProps ? this.context.allProps.detailsConfig : null);
      let tmpList = this.detailsTemporaryList || (this.context && this.context.allProps ? this.context.allProps.temporaryList : null);

      if (masterId || tmpList) {
        await FormsActions.createDetailEntity(masterFormConfig, detailsConfig, tmpList, masterId);
        return;
      }
      let clusterData = this.$refs.entititesList.getClusterData();
      if (clusterData) {
        let presetFld = {
          fieldName: clusterData.fieldName,
          value: clusterData.clusterId,
        };
        let presetFields = [presetFld];
        let context = {
          ...this.context,
          presetFields
        }
        await FormsActions.create(this.formConfig, {context});
        return;
      }
      await FormsActions.create(this.formConfig);

    },

    async deleteEntity() {

      if (this.hasPendingItems()) {
        return;
      }

      if (this.mode === 'select' && !this.editInSelectMode || !this.selectedEntity) {
        return;
      }
      await this.$emit("delete");
      if (this.customDelete) {
        return;
      }
      if (this.selectMode === "single") {
        await FormsActions.delete(this.selectedEntity, true);
        this.afterDeleteEntity();
      } else if (this.selectMode === "range" && this.selectedEntity.length === 1) {
        if (this.selectedEntity.dataStream && this.selectedEntity.dataStream.defaultSelectAll) {
          if (await DialogManager.yesNo($tr("formsListActivity.deleting", "Deleting #{1}", this.formConfig.entityPlural),
              $tr("formsListActivity.sure.delete.selected",
                  "Are you sure you want to delete selected #{1}?", this.formConfig.entityPlural), false)) {
            await deleteAsStream(this.selectedEntity, this.formConfig);
          }
        } else {
          await FormsActions.delete(this.selectedEntity[0], true);
        }
        this.afterDeleteEntity();
      } else if (this.selectMode === "range" && this.selectedEntity.length > 1) {
        if (this.selectedEntity.dataStream && this.selectedEntity.dataStream.defaultSelectAll) {
          if (await DialogManager.yesNo($tr("formsListActivity.deleting", "Deleting #{1}", this.formConfig.entityPlural),
              $tr("formsListActivity.sure.delete.selected.many.pt.1",
                  "Are you sure you want to delete selected ") + "<b>" + this.selectedEntity.length + "</b>" + $tr("formsListActivity.sure.delete.selected.many.pt.2", " elements from #{1}?", this.formConfig.entityPlural), false)) {
            await deleteAsStream(this.selectedEntity, this.formConfig);
          }
        } else {
          await FormsActions.deleteList(this.selectedEntity, true);
        }
        this.afterDeleteEntity();
      }
    },

    afterDeleteEntity() {
      if (!this.customDelete) {
        this.selectedEntity = null;
        this.$refs.entititesList.afterDeleteEntity();
      }
    },

    async select() {
      ActivityManager.findActivity(this).setResult(this.selectedEntity);
      this.close();
    },

    clear() {
      ActivityManager.findActivity(this).setResult(null);
      this.close();
    },

    async showDetailsOrSelect() {
      if (this.mode === 'select') {
        return this.select();
      }
      await this.details();
    },

    hasPendingItems() {
      if (_.isArray(this.selectedEntity)) {
        if (this.selectedEntity.find(el => el.__pending__)) {
          return true;
        }
      } else {
        if (this.selectedEntity.__pending__) {
          return true;
        }
      }
      return false;
    },

    async details() {
      if (this.mode === 'select' && !this.editInSelectMode || !this.selectedEntity) {
        return;
      }
      if (!this.showDetails) {
        return;
      }

      if (this.hasPendingItems()) {
        return;
      }

      let masterFormConfig = this.detailsMasterFormConfig || (this.context && this.context.allProps ? this.context.allProps.masterFormConfig : null);
      let detailsConfig = this.detailsConfig || (this.context && this.context.allProps ? this.context.allProps.detailsConfig : null);
      let tmpList = this.detailsTemporaryList || (this.context && this.context.allProps ? this.context.allProps.temporaryList : null);
      let masterId = this.detailsMasterId || (this.context && this.context.allProps ? this.context.allProps.masterId : null);

      if (this.selectMode === "single") {
        // await FormsActions.editDetail(this.selectedEntity, this.detailsConfig, this.masterId,
        //     {detailsConfig: this.detailsConfig, showDelete:this.detailsConfig.deleteEnabled};
        let res = await this.$emit("details", this.selectedEntity);
        this.customDetails || await FormsActions.editDetail(this.selectedEntity, detailsConfig, masterId,
            {showDelete: this.showDelete});
      } else if (this.selectMode === "range" && this.selectedEntity.length === 1) {
        let res = await this.$emit("details", this.selectedEntity[0]);
        if (this.formConfig.isView) {
          await FormsActions.editView(this.formConfig, this.selectedEntity[0], {showDelete: this.showDelete});
        } else {
          this.customDetails || await FormsActions.editDetail(this.selectedEntity[0], detailsConfig, masterId,
              {showDelete: this.showDelete});
        }
      }
    },

    filterOtherProducts() {
      this.$emit("filter-other-products");
    },

    async importData() {
      if (this.mode === 'select' && !this.editInSelectMode) {
        return;
      }
      let res = await this.$emit("import");
      this.customAdd || await FormsActions.importData(this.formConfig);
    },

    async loadDynamicData() {
      if (await checkIfThereAreDynamicFieldsOnTheGrid(this.formConfig)) {
        let dynamicRowsFormConfig;
        if (SessionManager.featureFlagsSet[FeatureFlag.STREAMING_LISTS] && this.formConfig.streamingMode) {
          [this.dynamicRows, dynamicRowsFormConfig] = await getRecordsFromDatabaseWithRowsWhenStreaming(this.formConfig, this.formConfig.formClassLong, this.context ? this.context.onlyIds : null, this.context ? this.context.excludedIds : null);
        } else {
          [this.dynamicRows, dynamicRowsFormConfig] = await getAllRecordsFromDatabaseWithRows(this.formConfig.formClassLong);
        }
        [this.dynamicCells, this.dynamicCellFormConfig] = await getAllRecordsFromDatabaseWithDynamicCells(this.formConfig.dynamicCells, this.dynamicRows);
        if (this.dynamicCells.length > 0) {
          [this.dynamicColumns, this.dynamicColsFormConfig, this.uniqueDataForColoringDynamicColumns] =
              await getAllRecordsFromDatabaseWithDynamicColumns(this.formConfig.dynamicColumns, this.dynamicCells, this.dynamicCellFormConfig);
        }
      }
    },

    async createDynamicColumns() {

      if (this.dynamicRows.length !== 0 && this.dynamicCells.length !== 0
          && this.dynamicColumns.length === Object.keys(this.dynamicRows[0]?.__supplement__?.dynamicColumns).length) {

        let filedConfigFromDynamicCellsToEdit = this.dynamicCellFormConfig.fields.filter(field => field.fieldName === this.dynamicCellFormConfig.cellValueFieldForDynamicColumns);
        this.listOfDynamicPreparedObjectForColumns = [];
        for (let i = 0; i < this.dynamicColumns.length; i++) {
          const column = this.dynamicColumns[i];

          let label = FormsAI.getEntityLabel(null, column.columnLabelEntity)
          let tempComputedColsFromEntitiesList = {
            autoSize: false,
            // cellProperties: computedCols[2].cellProperties,
            colId: column.columnEntity.id,
            colsManager: null,
            dataGrid: this,
            fieldConfig: filedConfigFromDynamicCellsToEdit[0],
            formConfig: this.dynamicCellFormConfig,
            template: DefaultCellTextRenderer,
            gridOrder: this.formConfig.fields[this.formConfig.fields.length - 1].gridOrder += 100,
            id: column.columnEntity.id,
            name: label,
            prop: "__" + column.columnEntity.id + "__",
            searchable: false,
            size: 100,
            sortable: false,
            toFilterStr: null,
            toStr: null,
            visible: true,
            dynamicColumn: true,
            base: column.columnEntity.base,
            editable: column.columnEntity.editable
          }

          if (this.uniqueDataForColoringDynamicColumns !== null && this.dynamicColsFormConfig !== undefined &&
              this.dynamicColsFormConfig.fieldByWhichColoringWillBeDistinguishedForDynamicColumns !== null) {
            let redValue = 175;
            for (let value of this.uniqueDataForColoringDynamicColumns) {
              redValue += 30;
              let valueFromFormConfig = this.dynamicColsFormConfig.fieldByWhichColoringWillBeDistinguishedForDynamicColumns
              if (column.columnEntity[valueFromFormConfig] === value && redValue <= 255) {
                tempComputedColsFromEntitiesList.cssHStyle = {"background": `rgb(${redValue}, 211, 255)`};
                tempComputedColsFromEntitiesList.customCssHStyleValue = redValue;
              }
            }
          }

          tempComputedColsFromEntitiesList.cellTemplate = VGridVueTemplate(tempComputedColsFromEntitiesList.template);

          this.listOfDynamicPreparedObjectForColumns.push(tempComputedColsFromEntitiesList);
        }
      }
    },

    async changeVisibilityForSelectMode(selection) {
      if (this.mode === 'select') {
        if (this.showMultiSelect) {
          if (selection instanceof Array) {
            this.anySelectionItem = selection.length;
            return;
          }
          if (this.formConfig.streamingMode) {
            let selectedItems = [];
            if (selection.materialize) {
              await selection.materialize();
              for (let item of selection) {
                selectedItems.push(item);
              }
            }
            this.anySelectionItem = selectedItems.length;
          } else {
            this.anySelectionItem = selection.length;
          }
        }
      }
    }
  },

  props: {
    hasWriteAccessToMaster: {default: null},
    customDataLoader: {default: null},
    // selectMode: {type: String, default: "range"},

    items: {
      default: function () {
        return []
      }
    },
    formType: {required: true},
    showAdd: {default: true},
    showDelete: {default: true},
    showDetails: {default: true},
    filteringMode: {default: false},

    customDetails: {default: false},
    customAdd: {default: false},
    customDelete: {default: false},
    columnMixins: {type: Array, default: () => []},
    toolboxMixins: {type: Array, default: () => []},

    editInSelectMode: {default: false},

    context: {default: null},
    callingFormConfig: {default: null},
    filter: {default: null},

    detailsConfig: {default: null},
    detailsMasterId: {default: null},
    detailsMode: {default: null},
    detailsTemporaryList: {default: null},
    detailsMasterFormConfig: {default: null},
    metaStatus: {default: null},
    recordsWithChosenFilters: {default: null},
    propSelectionSize: 0,
    propShowMultiSelect: false,
    propMultiSelect: false,
    editMultiSelectFromTab: {default: false},
    selectFormat: "ID_ONLY",
    streamRowsPostProcess: {default: null}
  },

  model: {
    event: 'selected'
  },
  watch: {
    filter: function (val) {
      console.log(val);
    },
    selectedEntity: async function (val) {
      await this.changeVisibilityForSelectMode(val);
      this.$emit('selected', val);
    },
    selectedIndex: function (val) {
      this.anySelectionItem = true;
      this.$emit('selectedIndex', val);
    },
    selectionSize: function (val) {
      this.$emit("update:propSelectionSize", this.selectionSize);
    },
    showMultiSelect: function (val) {
      this.$emit("update:propShowMultiSelect", this.showMultiSelect);
    },
    editMultiSelectFromTab: function (val) {
      this.$emit("update:editMultiSelectFromTab", val);
    },
  },

  data: function () {
    return {
      effectiveHasWriteAccessToMaster: (this.hasWriteAccessToMaster ?? (!this.detailsMode)),
      selectedEntity: null,
      anySelectionItem: false,
      selectMode: (this.multiSelect || this.context?.multiSelect || this.propMultiSelect) ? "range" : "single",
      multiSelectAutoOn: this.multiSelectAutoOn || this.context?.multiSelectAutoOn,
      contextShowAdd: true,
      contextShowDelete: true,
      formId: this.callingFormConfig?.formId ?? FormsLoader.detectFormConfig(this.formType).formId,
      formConfig: this.callingFormConfig ?? FormsLoader.detectFormConfig(this.formType),
      allowNullSelection: false,

      /** @type{CompanyInfo[]} */
      selectedIndex: null,
      selectionSize: 0,

      grid: null,
      permissions: new PermissionsSet(),

      mode: this.context?.mode ?? "browse",
      showMultiSelect: false,
      readyToShow: false,

      dynamicColumns: [],
      dynamicCells: [],
      dynamicColsFormConfig: null,
      dynamicCellFormConfig: null,
      uniqueDataForColoringDynamicColumns: null,
      listOfDynamicPreparedObjectForColumns: [],
    }
  },

}
</script>